export default {"src":"/_next/static/media/sort.6c492742.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};